import { LightningElement, api } from "lwc";

class FilterSort extends LightningElement {
  @api sort = null;
  @api handleControlFocus() {
    const formControl = this.template.querySelector("lwc-tds-form-control");
    formControl?.focus();
  }
  handleSort(e) {
    this.dispatchEvent(new CustomEvent("sort", e));
  }
  get config() {
    return {
      toggleDisabled: true,
      ...this.sort,
    };
  }
}

export default FilterSort;
